import type { MusicalPieceLanguage } from '@/types';

export type PieceLanguage = NonNullable<MusicalPieceLanguage>;

/** Every language, in the order the pickers and filters list them. */
const PIECE_LANGUAGES: PieceLanguage[] = [
  'English',
  'Cantonese',
  'Mandarin',
  'Japanese',
  'Korean',
  'Others',
];

/** Language values double as their own labels, so one item list serves every select. */
export const PIECE_LANGUAGE_ITEMS = PIECE_LANGUAGES.map((language) => ({
  label: language,
  value: language,
}));
